export default "__VITE_ASSET__91b39266__"